import platform from 'platform';

export function getPlatformData() {
    const data = {
        platform: platform.name,
        device: platform.product,
        device_manufacturer: platform.manufacturer,
        device_model: platform.product,
        os_name: platform.os.family,
        os_version: platform.os.version,
    };

    if (!data.device_manufacturer) {
        if (data.os_name === 'OS X') {
            data.device_manufacturer = 'Apple';
        }
    }

    return data;
}

export function getPageViewData() {
    const referrer = document.referrer || '';
    const browser = `${platform.name || 'Unknown'} ${platform.version || ''}`.trim();
    const os = platform.os?.family || 'Unknown';
    const page = window.location.href;
    const userAgent = navigator.userAgent;

    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;

    return {
        strings: [referrer, browser, os, page, userAgent],
        numbers: [screenWidth, screenHeight],
    };
}
